import React from 'react'

import ReactCodeInput from 'react-verification-code-input'
import styles from './styles.module.scss'

const CodeVerificationBox = ({ customClassName, fields, onChange, ...props }) => {
  return (
    <ReactCodeInput
      className={`${styles.codeInput} ${customClassName}`}
      fields={fields}
      onChange={onChange}
      {...props}
    />
  )
}

export default CodeVerificationBox
